import type { TeamWith } from "@redotech/account-common/base-team";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import type { OutboundLabelSettings } from "@redotech/redo-fulfillment-settings/outbound-label-settings";
import { PackingSlip } from "@redotech/redo-model/packing-slips/packing-slip-definition";
import { PersonalizedSlip } from "@redotech/redo-model/personalized-slip/personalized-slip-definition";
import { useMemo } from "react";

export function useSelectedPackingSlipSizes(
  packingSlips: PackingSlip[],
  fulfillmentGroups: readonly FulfillmentGroupData[],
  team: TeamWith<{ outboundLabels: OutboundLabelSettings }> | undefined,
) {
  return useMemo(() => {
    return packingSlips
      .filter((packingSlip) =>
        fulfillmentGroups.some(
          ({ packingSlipTemplateId }) =>
            (packingSlipTemplateId ||
              team?.settings?.outboundLabels?.packingSlipId) ===
            packingSlip._id,
        ),
      )
      .reduce(
        (set, packingSlip) => set.add(packingSlip.pageLayout.size),
        new Set<string>(),
      );
  }, [
    packingSlips,
    fulfillmentGroups,
    team?.settings?.outboundLabels?.packingSlipId,
  ]);
}

export function useSelectedPersonalizedSlipSizes(
  personalizedSlips: PersonalizedSlip[],
  fulfillmentGroups: readonly FulfillmentGroupData[],
) {
  return useMemo(() => {
    return personalizedSlips
      .filter((personalizedSlip) =>
        fulfillmentGroups.some(
          ({ personalizedSlipTemplateId }) =>
            personalizedSlipTemplateId === personalizedSlip._id,
        ),
      )
      .reduce(
        (set, personalizedSlip) =>
          set.add(personalizedSlip.globalSettings.pageLayout?.size),
        new Set<string | undefined>(),
      );
  }, [personalizedSlips, fulfillmentGroups]);
}
